import css from "styled-jsx/css";

export const componentStyles = css`
  .home-page-product-cards {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
`;
